module.exports = __webpack_public_path__ + "static/media/satoshi.b25b8173.jpg";